const PayrollEntrySkeleton = () => (
  <div className="space-y-3">
    {[...Array(5)].map((_, i) => (
      <div key={i} className="flex items-center justify-between p-4 border rounded-lg animate-pulse">
        <div className="flex items-center gap-4">
          <div className="w-4 h-4 bg-muted rounded" />
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-muted rounded-full" />
            <div className="space-y-1">
              <div className="w-32 h-4 bg-muted rounded" />
              <div className="w-24 h-3 bg-muted rounded" />
            </div>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <div className="text-center space-y-1">
            <div className="w-12 h-4 bg-muted rounded" />
            <div className="w-16 h-3 bg-muted rounded" />
          </div>
          <div className="text-center space-y-1">
            <div className="w-16 h-4 bg-muted rounded" />
            <div className="w-12 h-3 bg-muted rounded" />
          </div>
          <div className="text-center space-y-1">
            <div className="w-16 h-4 bg-muted rounded" />
            <div className="w-14 h-3 bg-muted rounded" />
          </div>
          <div className="text-center space-y-1">
            <div className="w-20 h-4 bg-muted rounded" />
            <div className="w-10 h-3 bg-muted rounded" />
          </div>
          <div className="w-16 h-6 bg-muted rounded-full" />
          <div className="w-6 h-6 bg-muted rounded" />
        </div>
      </div>
    ))}
  </div>
);

export default PayrollEntrySkeleton;
